import * as browser from "webextension-polyfill";
export function getLocaleInfo() {
    return {
        locale: browser.i18n.getUILanguage(),
        readingDirection: browser.i18n.getMessage("@@bidi_dir"),
    };
}
